import { render, staticRenderFns } from "./mdbWysiwyg.vue?vue&type=template&id=29784248&scoped=true&"
import script from "./mdbWysiwyg.vue?vue&type=script&lang=js&"
export * from "./mdbWysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./mdbWysiwyg.vue?vue&type=style&index=0&id=29784248&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29784248",
  null
  
)

export default component.exports